import {Box} from "@mui/material";
import React, {Fragment, useState} from "react";
import DisableCompanyConfirmationModal from "./DisableCompanyConfirmationModal";
import {Tooltip} from "@mui/material";
import useGetDisableProcesses from "../../hooks/useGetDisableProcesses";
import CircularProgress from "@mui/material/CircularProgress";
import commonStyles from "../../organizationMainStyles";
import DisableProcess from "./DisableProcess";
import ActionButton from "../../../../common/ActionButton";
import {accessibilityMode, fragmentId} from "../organizationSettingsConstants";
import {getLabel} from "../organizationSettingsUtils";
import InformationTooltip from "../InformationTooltip";

function DisableProcesses({disableProcesses}) {
    return (
        disableProcesses ?
            <Box sx={styles.sectionWrapper}>
                {disableProcesses.map((disableProcess) => (
                    <DisableProcess key={disableProcess.id} disableProcess={disableProcess}/>
                ))}
            </Box> : <Fragment/>
    )
}

function DisableCompanyTitle({label}) {
    return (
        <Box sx={styles.text}>
            {label.DISABLE_COMPANY}
            <InformationTooltip label={"Disable the company, remove data integrations, and remove all attached users from Teams. They will no longer be able to log in, and will no longer be visible in the\n" +
                " expert or admin Teams application. This should be done when the company is offboarded."} />
        </Box>
    )
}

export default function DisableCompany({organizationId, mode}) {
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const {disableProcesses, loading} = useGetDisableProcesses(organizationId);
    const label = getLabel(fragmentId.OFF_BOARD);
    const toggleConfirmationModal = () => setOpenConfirmationModal(!openConfirmationModal);

    const handleDisable = () => {
        toggleConfirmationModal()
    };

    const isDisableDisabled = loading || disableProcesses.disableInProgress;

    const BodyContent = () => {
        if (loading) {
            return (
                <Box sx={commonStyles.bodyLoading}>
                    <CircularProgress sx={commonStyles.bodyLoadingSpinner}/>
                </Box>
            )
        }
        return (
            <Box sx={{mt: '15px'}}>
                <DisableCompanyConfirmationModal
                    openConfirmationModal={openConfirmationModal}
                    closeConfirmationModal={toggleConfirmationModal}
                    organizationName={disableProcesses.organizationName}
                    organizationId={organizationId}
                />
                <Box sx={styles.headerSection}>
                    <DisableCompanyTitle label={label}/>
                    {mode === accessibilityMode.EDIT &&
                        <Box>
                            <Tooltip title="The disable process is in progress"
                                     disableHoverListener={!isDisableDisabled}>
                            <span>
                                <ActionButton
                                    label={'Disable'}
                                    action={handleDisable}
                                    withIcon={false}
                                    disabled={isDisableDisabled}
                                    sx={styles.disableButton}
                                />
                            </span>
                            </Tooltip>
                        </Box>
                    }
                </Box>
                <DisableProcesses disableProcesses={disableProcesses.items}/>
            </Box>
        )
    }

    return <BodyContent/>
}

const styles = {
    headerSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        justifyContent: 'space-between'
    },
    text: {
        fontSize: '16px',
        fontFamily: 'LarsseitMedium',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    infoIcon: {
        fontSize: '18px'
    },
    disableButton: {
        width: '100px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}